<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.department.searchByDepartment')"
                        solo
                        height="40"
                        @keyup.enter="getDepartmentPagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="searchDepartment()"
                        color="primary"
                        outlined
                        height="40">
                        {{ $vuetify.lang.t('$vuetify.department.search') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="permissionCreate"
                    @click="openFormDepartmentModal(null)"
                    height="40px"
                    color="primary">
                    + {{ $vuetify.lang.t('$vuetify.department.createNewDepartment') }}
                </v-btn>
            </div>
        </div>

        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalDepartment"
                :items="departments"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-icon
                            v-if="permissionUpdate"
                            class="mr-2"
                            @click="openFormDepartmentModal(item)">
                            edit
                        </v-icon>
                        <v-icon
                            v-if="permissionDelete"
                            class="mr-2"
                            @click="openDeleteDepartmentModal(item)">
                            delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <departmemt-form-modal
            @success-created="getDepartmentPagination()"
            @success-updated="getDepartmentPagination()"
            ref="departmentFormModal"/>

        <delete-modal
            ref="modalDeleteDepartment"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal'
import DepartmemtFormModal from '@/components/modal/DepartmemtFormModal'
import permissionConstant from '@/constants/permissions.js'

export default {
    name: 'DepartmentList',

    components: {
        DeleteModal,
        DepartmemtFormModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalDepartment: 0,
            departments: [],
            permissionCreate: true,
            permissionUpdate: true,
            permissionDelete: true,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            }
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.department.department'), value: 'name', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.department.description'), value: 'description', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.department.manager'), value: 'manager', width: '13%' },
                { text: this.$vuetify.lang.t('$vuetify.department.managerContact'), value: 'manager_contact', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.department.contactNo'), value: 'contact_no', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.department.totalStaff'), value: 'total_staff', width: '12%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        }
    },

    methods: {
        async openFormDepartmentModal (department = null) {
            this.$refs.departmentFormModal.openModal(department)
        },

        async openDeleteDepartmentModal (department) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.department.deleteDepertment')
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.department.wantToDelete')} "${department.name}"?`
            this.deleteForm.path = `department/delete/${department.id}`
            this.$refs.modalDeleteDepartment.dialog = true
        },

        async deleteSuccess () {
            await this.getDepartmentPagination()
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.department.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.department.departmentIsDeleted'),
                type: 'success'
            })
        },

        async searchDepartment () {
            this.options.page = 1
            await this.getDepartmentPagination()
        },

        async getDepartmentPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `departments?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.departments = res.data.data
                this.totalDepartment = res.data.total
                this.loading = false
            }
        },

        checkPermission () {
            this.permissionCreate = this.$util.checkPermission(permissionConstant.department.create)
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.department.update)
            this.permissionDelete = this.$util.checkPermission(permissionConstant.department.delete)
        }
    },

    mounted () {
        this.checkPermission()
    },

    watch: {
        options: {
            async handler () {
                await this.getDepartmentPagination()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}
</style>
